export const currencySignMap: {[key: string]: string} = {
  usd: '$',
  eur: '€',
  gbp: '£',
  cad: 'CA$',
  aud: 'A$',
  jpy: '¥',
  inr: '₹',
  cny: '¥',
  chf: 'Fr.',
  mxn: '$',
  rub: '₽',
  sek: 'kr',
  nok: 'kr',
  try: '₺',
  zar: 'R',
  hkd: 'HK$',
  sgd: 'S$',
  krw: '₩',
  myr: 'RM',
  bdt: '৳',
  php: '₱',
  vnd: '₫',
  idr: 'Rp',
  thb: '฿',
}
